import React from 'react'

// Top-level error boundary. Especially important here because .jsx files are
// NOT type-checked (tsc only covers .tsx), so an undefined-variable render
// error can ship — without a boundary it white-screens the entire SPA.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Unhandled render error:', error, info?.componentStack)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
        <div className="max-w-md w-full rounded-xl border border-rose-200 bg-white p-8 text-center shadow-sm">
          <h1 className="text-lg font-semibold text-slate-900">Something went wrong</h1>
          <p className="mt-2 text-sm text-slate-500">
            The page hit an unexpected error. Reloading usually fixes it — if it keeps
            happening, let an admin know what you were doing.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            className="mt-6 rounded-md bg-accent-600 px-4 py-2 text-sm font-medium text-white hover:bg-accent-500"
          >
            Reload page
          </button>
        </div>
      </div>
    )
  }
}
